<template>
  <v-card>
    <v-card-title class="headline">
      {{editMode?'Редактировать':'Добавить'}} папку
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    
    <v-card-text>
      <small v-if="type===3 && folder.owner_id && owner">Только доступные для редактирования папки поста "{{owner}}"</small>
      <dantser-tree
        label="Родительская папка"
        :source="foldersTree"
        ref="parentFolder"
        :field="true"
        :selectMode="1"
        @node-dblclick="setParent($event)"
      >
      </dantser-tree>
      
      
      <v-text-field v-model="folder.name" label="Название"></v-text-field>
      <p class="mt-2 mb-0 body-2"><label>Область видимости</label></p>
      <dantser-scope :treedata="treedata" withScopes withEdit v-model="folder.scopes"></dantser-scope>
    </v-card-text>
    
    <v-card-actions class="pa-3">
      <v-btn color="success" dark @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {mapGetters} from 'vuex'
  
  export default {
    name : "FolderForm",
  
    props:{
      data:{
        type: Object,
        required: false,
        default: () => { return {
          name: '',
          parent_id: null,
          scopes: []
        }}
      },
      type: {
        type: Number,
        required: false,
        default: 0
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    
    computed:{
      ...mapGetters('app/org', ['getPostById','getContainerById']),
    },
  
    mounted(){
      this.folder = JSON.parse(JSON.stringify(this.data))
      this.getTrees()
      if(this.type===3 && this.folder.owner_id && this.folder.owner_id.length>0){
        let post = this.getPostById(this.folder.owner_id)
        if(post.loaded){
          this.owner = post.name
        } else {
          this.$store.dispatch('app/org/entitiesInfo', { posts: [this.folder.owner_id], containers: [] }).then( response => {
            if(response.posts_data && response.posts_data[0]){
              this.$store.commit('app/org/addPosts', response.posts_data)
              this.owner = response.posts_data[0].name
            }
          })
        }
      }
    },
    
    data(){
      return {
        status:{
          btnDisabled: false,
          text: '',
          className:'green--text darken-1'
        },
        folder:{},
        treedata: [],
        foldersTree: [],
        owner: ''
      }
    },
    
    methods:{
      getTrees(){
        this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
          this.treedata = usersTree
        })
        //Get Folders tree without current folder
        let id = (this.editMode) ? this.folder.id : '0'
        
        this.$store.dispatch('analytics_old/indicators/getFolders', {id: id, type: this.type}).then( foldersTree => {
          this.foldersTree = foldersTree
          this.foldersTree.unshift({
            id: null,
            name: 'Не выбрано',
            icon: 'mdi mdi-square'
          })
          this.$nextTick(function(){
            this.$refs['parentFolder'].setSelected(this.folder.parent_id)
          })
        })
        
        if(this.editMode){
          this.$store.dispatch('analytics_old/indicators/folderScopes', this.folder.id).then( scopes => {
            this.$set(this.folder, 'scopes', scopes)
            let posts = []
            let containers = []
            scopes.map( item => {
              if (item.element_type==="container"){
                let container = this.getContainerById(item.element_id)
                if(container.loaded){
                  item.name = container.name
                } else if(!containers.includes(item.element_id)){
                  containers.push(item.element_id)
                }
              } else if(item.element_type==="post"){
                let post = this.getPostById(item.element_id)
                if(post.loaded){
                  item.name = post.name
                } else if(!posts.includes(item.element_id)){
                  posts.push(item.element_id)
                }
              }
            })
  
            if(posts.length>0 || containers.length>0){
              this.$store.dispatch('app/org/entitiesInfo', { posts, containers }).then( response => {
                this.$store.commit('app/org/addPosts', response.posts_data)
                response.posts_data.map( post => {
                  const index = this.folder.scopes.findIndex( el => el.element_id===post.id)
                  if (index>=0) this.folder.scopes[index].name = post.name
                })
  
                this.$store.commit('app/org/addContainers', response.containers_data)
                response.containers_data.map( container => {
                  const index = this.folder.scopes.findIndex( el => el.element_id===container.id)
                  if (index>=0) this.folder.scopes[index].name = container.name
                })
              })
            }
          })
        }
      },
  
      setParent(eventData){
        this.folder.parent_id = eventData.id
      },
      
      submit(){
        this.status={ btnDisabled: true, text: 'Сохранение', className:'grey--text lighten-1' }
  
        if(this.editMode){
          this.$store.dispatch('analytics_old/indicators/updateFolder', this.folder).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
            this.$emit('save', {type: 'folder', data: this.folder})
          }).catch( error => {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
          })
        } else {
          this.$store.dispatch('analytics_old/indicators/createFolder', this.folder).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
            this.folder.id = response.id
            this.folder.icon = 'mdi mdi-folder'
            this.folder.element_type = 'folder'
            this.folder.children = []
            this.folder.can_edit = true
            this.$emit('save', {type: 'folder', data: this.folder})
          }).catch( error => {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/Forms/FolderForm.vue